import { UserTargetAPI } from 'constants/trading';

export interface AuthRefreshResponse {
  access_token: string;
  refresh_token: string;
}

export interface PostAuthTokenResponse {
  token: string;
  target: UserTargetAPI;
}

export enum AccountTypeEnum {
  EQUITY = 'ACCOUNT_TYPE_EQUITY',
  SYARIAH = 'ACCOUNT_TYPE_SYARIAH',
  BOND = 'ACCOUNT_TYPE_BOND',
  DAY_TRADING = 'ACCOUNT_TYPE_DAY_TRADING',
}

export interface AccountResponse {
  type: AccountTypeEnum;
  number: string;
}

export interface PostAuthPINResponse {
  access_token: string;
  refresh_token: string;
  account: AccountResponse;
}

export type LoginRealResponse = {
  loginToken: string;
  target: UserTargetAPI;
  accessToken: string;
  refreshToken: string;
};
